import type { RouteConfig } from "@/types/routestypes";
import { lazy } from "react";

const MyTask = lazy(() => import("@/pages/MyTask/MyTaskPage"));

const MyTaskRoute: RouteConfig = {
    path: "/mytask",
    element: <MyTask />,
    pageName: "My Task",
    sidebar: { show: true, icon: "/assets/media/taskLogo.svg" },
    permission: ["TaskView"]
}

export default MyTaskRoute

